<template>
  <div>
    <v-text-field
      label="Mağaza Sahibi Adı / Soyadı"
      v-model="localData.ownerName"
      @input="emitUpdate"
      :rules="fullNameRules"
    />
    <v-text-field
      label="Ticaret Ünvanı"
      v-model="localData.companyTitle"
      @input="emitUpdate"
    />
    <small style="color: #98a2b3; font-size: 11px; margin-top: -5px;">
      Ticaret Ünvanı banka hesap sahibiyle aynı olmalıdır.
    </small>

    <div style="margin-top: 16px; color: darkslategray;">Şirket Türü</div>
    <v-radio-group
      v-model="localData.companyType"
      row
      style="margin-left: 8px;"
    >
      <v-radio value="Individual" class="custom_radio">
        <template v-slot:label>
          <v-img
            :src="require('../../assets/icons/individual.svg')"
            contain
            class="mr-2"
          />
          <div>
            Şahıs
          </div>
        </template>
      </v-radio>
      <v-radio value="Limited" class="custom_radio">
        <template v-slot:label>
          <v-img
            :src="require('../../assets/icons/limited.svg')"
            contain
            class="mr-2"
          />
          <div>
            Limited
          </div>
        </template>
      </v-radio>
      <v-radio value="Stock" class="custom_radio">
        <template v-slot:label>
          <v-img
            :src="require('../../assets/icons/anonim.svg')"
            contain
            class="mr-2"
          />
          <div>
            Anonim
          </div>
        </template>
      </v-radio>
    </v-radio-group>
    <v-text-field
      label="Kep Adresi"
      v-model="localData.kepAddress"
      @input="emitUpdate"
    />
    <v-text-field
      label="Şirket Eposta Adresi"
      v-model="localData.companyMail"
      @input="onEmailChange"
      :rules="emailRules"
      @keydown.space.prevent
    />
  </div>
</template>

<script>
export default {
  name: 'CompanyInfoForm',
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData },
      emailRules: [
        (v) => !!v || 'Email alanı zorunludur.',
        (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'Lütfen geçerli bir mail adresi giriniz.',
      ],
      fullNameRules: [
        (v) => !!v || 'Ad ve soyadı doğru bir formatta yazınız.',
        (v) => v.length <= 255 || 'Ad ve soyadı doğru bir formatta yazınız.',
        (v) => {
          const parts = v
            .trim()
            .split(' ')
            .filter((part) => part.length > 0)
          return (
            (parts.length >= 2 && parts.every((part) => part.length >= 2)) ||
            'Ad ve soyadı doğru bir formatta yazınız.'
          )
        },
        (v) =>
          /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]*$/.test(v) ||
          'Ad ve soyadı doğru bir formatta yazınız.',
      ],
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update-form-data', 'companyInfo', this.localData)
    },
    onEmailChange(value) {
      this.localData.companyMail = value.replaceAll(/\s+/g, '')
      this.emitUpdate()
    },
  },
  watch: {
    'localData.companyType'() {
      this.$emit('update-form-data', 'companyInfo', this.localData);
    }
  }
}
</script>
<style>
.custom_radio {
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 12px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  gap: 12px;
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0 !important;
}
</style>
